import { useState, useMemo } from "react";
import type { DeliveryProps, PerformanceProcessData } from "./type";
import { useIsomorphicEffect } from "~/hooks/use-isomorphic-effect";

export const useDeliverySearch = (args: DeliveryProps) => {
  const { videoStageSeasonData } = args;

  const isomorphicEffect = useIsomorphicEffect();

  const [performanceProcessData, setPerformanceProcessData] = useState<PerformanceProcessData[]>([]);

  /** `contentId`が同一のものを排除していない配列を生成する */
  const performanceProcessAllData = useMemo(() => {
    return videoStageSeasonData.allPerformances.flatMap(({ contents, performanceDate }) => {
      return contents.map((cur) => {
        return {
          contentId: cur.id,
          episodeTitle: cur.episodeTitle,
          performanceDate,
          priority: cur.priority,
          ppvProducts: cur.ppvProducts,
        };
      });
    });
  }, []);

  /** `contentId`が同一のものが存在しない配列を生成する */
  const uniqueIdPerformanceProcessAllData = useMemo(() => {
    const uniqueIdArray = Array.from(
      new Map(
        performanceProcessAllData.map((cur) => {
          return [cur.contentId, { ...cur }];
        })
      ).values()
    );

    return uniqueIdArray;
  }, []);

  const filterPerformanceProcessData = ({ performanceDateArgs }: { performanceDateArgs: Date | null }) => {
    // nullの場合 = 全てを押下した場合
    if (performanceDateArgs === null) {
      setPerformanceProcessData(uniqueIdPerformanceProcessAllData);
      return;
    }

    // それ以外の場合は、引数に渡した公演日で絞り込みを行うようにする
    setPerformanceProcessData(() =>
      performanceProcessAllData.filter(({ performanceDate }) => performanceDate === performanceDateArgs)
    );
  };

  isomorphicEffect(() => {
    setPerformanceProcessData(uniqueIdPerformanceProcessAllData);
  }, []);

  return {
    /** videoStageSeasonData.allPerformancesを加工したデータ */
    performanceProcessData,
    /** 公演日で絞り込む検索を行うための関数 */
    filterPerformanceProcessData,
  };
};
